import { Helmet } from "react-helmet-async";
import { AppProvider } from "./providers/app.provider";
import AppRoutes from "./routes";
import GlobalStyle, { theme } from "./theme";
import "react-toastify/dist/ReactToastify.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import { ToastContainer } from "react-toastify";
import React from "react";

// console.log = () => {};
// console.error = () => {};

const App: React.FC = () => {
  return (
    <AppProvider>
      <GlobalStyle theme={theme} />
      <Helmet>
        <title>Zawaj Sounnah</title>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        {/*
          // @ts-ignore */}
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        {/* Fonts you want to use */}
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <ToastContainer />
      <AppRoutes />
    </AppProvider>
  );
};

export default App;
